import styled from 'styled-components';

/**
 * PageToolbar
 *
 * A reusable toolbar component for search inputs, filters, and action buttons.
 * Typically placed at the top of a data table or content area.
 *
 * Usage:
 * import PageToolbar from 'components/PageToolbar';
 *
 * <PageToolbar>
 *   <SearchInput onSearch={handleSearch} placeholder="Search..." />
 *   <Select value={filter} onChange={handleFilter} options={options} />
 *   <ButtonV2 onClick={handleAdd}>Add New</ButtonV2>
 * </PageToolbar>
 */

const PageToolbar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: ${(props) => (props.noWrap ? 'nowrap' : 'wrap')};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export default PageToolbar;
